module.exports = __webpack_public_path__ + "static/media/BINARY24.ecbf2501.jpg";